<template>
  <v-row no-gutters class="pt-4">
    <v-col :md="3" cols="12">
      <div
        class="d-flex align-center field-post-media"
        style="min-height: 45px"
      >
        <v-icon class="fab fa-youtube mr-3" size="40" color="#EB5757"> </v-icon>
        <translate>Youtube</translate>
      </div>
    </v-col>
    <v-col :md="9" cols="12">
      <v-text-field
        v-model="link"
        :rules="rules"
        :placeholder="$gettext('Youtube link')"
        hide-details="auto"
        outlined
        dense
      ></v-text-field>
      <v-img
        :src="youtubeImg"
        height="160"
        v-if="youtubeImg"
        class="mt-3 rounded-lg"
      />
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "YoutubeInputSingle",
  props: {
    value: { type: Array, default: () => [] },
    rules: {},
  },
  data() {
    return {
      link: "",
      search: null,
      youtubeImg: "",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (Array.isArray(val)) {
          let link = val[0];
          if (link) {
            if (link.youtubeId) {
              this.link = "https://www.youtube.com/watch?v=" + link.youtubeId;
            } else {
              this.link = link;
            }
          }
        } else this.link = val || "";
      },
    },
    link(val) {
      this.youtubeImg = "";
      if (val) {
        let id = this.getYoutubeId(val);
        if (id) {
          this.youtubeImg = `https://img.youtube.com/vi/${id}/0.jpg`;
        }
      }
      this.$emit("input", val ? [val] : []);
    },
  },
  methods: {
    reset() {
      this.link = "";
    },
    getYoutubeId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    },
  },
};
</script>
